import React from "react";
import { Section } from "../Section";
import { CTAButton } from "../CTAButton";
import { AUTHOR_PHOTO_URL } from "../../data/offer";
export function Author() {
  return <Section className="bg-mint-soft" data-id="element-66" data-mp="1wgoriw2yrl74">
      <div className="grid items-center gap-8 md:grid-cols-[0.8fr_1.2fr] md:gap-14" data-id="element-67" data-mp="1whqfg152w269">
        <div className="-mx-4 sm:mx-0" data-id="element-68" data-mp="1rpow5v9htb6q">
          <img src={AUTHOR_PHOTO_URL} alt="Dr. Elena Martins in her communication support office" className="aspect-[4/5] w-full object-cover object-top sm:rounded-[32px]" loading="lazy" data-id="element-69" data-mp="1ronjjmctwgmw" />
        </div>
        <div data-id="element-70" data-mp="2fft1c72bxizu">
          <p className="font-display text-sm font-semibold uppercase tracking-wider text-mint" data-id="element-71" data-mp="2fe84ubwgfpzc">Meet the educational author</p>
          <h2 className="mt-2 font-display text-[36px] font-bold leading-tight text-navy sm:text-5xl" data-id="element-72" data-mp="2ah7vns4b6740">Dr. Elena Martins</h2>
          <p className="mt-1 font-display text-lg font-semibold text-coral" data-id="element-73" data-mp="g2f4q6ede4ie">AAC & Communication Support Specialist</p>
          <p className="mt-1 text-xs font-semibold text-ink/60" data-id="element-74" data-mp="3gew8p7q9pbkd">Fictional author persona for this educational product.</p>

          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink/85" data-id="element-75" data-mp="3kgzjrv90ye54">
            <p className="font-display text-xl font-semibold leading-snug text-navy" data-id="element-76" data-mp="3peiy0v5q2qx2">
              "I believe that organizing speech sound planning resources can make it easier for professionals to
              approach their work with greater clarity."
            </p>
            <p data-id="element-77" data-mp="31sw4ue1kq6i">
              I wanted this collection to bring planning worksheets, speech sound observation tools, visual activity
              resources, and documentation templates together in one practical reference.
            </p>
            <p data-id="element-78" data-mp="gzhbxnt9574p">
              Rather than suggesting that every child should follow the same sequence, these materials are intended to
              help you organize relevant information and prepare resources that fit your professional context.
            </p>
            <p data-id="element-79" data-mp="3m1i3osvmzhsx">
              You can use the collection to organize your observations, prepare activities, document follow-up, and
              identify questions that may require further assessment.
            </p>
            <p className="font-bold text-navy" data-id="element-80" data-mp="3v2pny71bii40">
              My goal is simple: to provide an educational reference you can return to when organizing your
              articulation-related work.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-12" data-id="element-81" data-mp="8t5adjafzf84">
        <CTAButton label="Start with the Blueprint today" data-id="element-82" data-mp="3vwnx6i9gp12" />
      </div>
    </Section>;
}